import { Box } from "@mui/material";
import { useId } from "react";
import {
    PUZZLE_3D_BEVEL_FILTER_BASE,
    PUZZLE_3D_DIE_STROKE,
    Puzzle3DBevelFilter,
} from "./Puzzle3DBevelFilter";

const overlayBaseSx = {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    display: "block",
};

/**
 * Jigsaw die-line overlay with 3D cardboard bevel (`puzzle-3d-bevel` filter).
 *
 * @param {object} props
 * @param {{ key?: string|number, d?: string, path?: string }[]} props.paths — piece outline paths
 * @param {number} [props.viewBoxWidth=1536]
 * @param {number} [props.viewBoxHeight=1536]
 * @param {string} [props.preserveAspectRatio="xMidYMid meet"]
 * @param {number} [props.strokeWidth=1.35]
 * @param {number} [props.opacity=1]
 * @param {number} [props.zIndex=1]
 * @param {object} [props.sx]
 */
export default function JigsawDieLine3DOverlay({
    paths,
    viewBoxWidth = 1536,
    viewBoxHeight = 1536,
    preserveAspectRatio = "xMidYMid meet",
    strokeWidth = 1.35,
    opacity = 1,
    zIndex = 1,
    sx = {},
}) {
    const reactId = useId().replace(/:/g, "");
    const filterId = `${PUZZLE_3D_BEVEL_FILTER_BASE}-${reactId}`;

    const list = Array.isArray(paths) ? paths.filter((p) => p?.d || p?.path) : [];
    if (list.length === 0) return null;

    return (
        <Box
            component="svg"
            viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
            preserveAspectRatio={preserveAspectRatio}
            sx={{ ...overlayBaseSx, zIndex, opacity, ...sx }}
            aria-hidden
        >
            <defs>
                <Puzzle3DBevelFilter filterId={filterId} />
            </defs>
            {list.map((p, i) => (
                <path
                    key={p.key ?? p.index ?? i}
                    d={p.d ?? p.path}
                    fill="none"
                    stroke={PUZZLE_3D_DIE_STROKE}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    vectorEffect="nonScalingStroke"
                    filter={`url(#${filterId})`}
                />
            ))}
        </Box>
    );
}

export { Puzzle3DBevelFilter, PUZZLE_3D_DIE_STROKE, PUZZLE_3D_BEVEL_FILTER_BASE };
